import React, { Fragment } from 'react';
import { Row, Col } from 'reactstrap';
import { PageAnimation } from '../../Layout/Components/Animation';
import PageTitle from '../../Layout/Components/PageTitle';
import Strings from '../../translations/Translations';
import CreateCampaignModule from '../../modules/campaign/create/CreateCampaignModule';

export default function CreateCampaign() {
  return (
    <Fragment>
      <PageAnimation>
        <PageTitle
          heading={Strings('create_campaign')}
          subheading={Strings('create_a_campaign_to_engaje_and_grow_your_users')}
          icon='pe-7s-display1'
        />

        <Row>
          <Col>
            <CreateCampaignModule />
          </Col>
        </Row>
      </PageAnimation>
    </Fragment>
  );
}
